import { FormInput, Paragraph, YStack } from "@medbillai/ui";
type Props = {
  text?: string;
  errorMessage?: string;
  onChangeText: (text: string) => void;
  onFocus?: () => void;
};
export default function AdditionalInfo({
  text,
  errorMessage,
  onChangeText,
  onFocus
}: Props) {
  return <YStack data-sentry-element="YStack" data-sentry-component="AdditionalInfo" data-sentry-source-file="AdditionalInfo.tsx">
      <Paragraph bold pb="$3" data-sentry-element="Paragraph" data-sentry-source-file="AdditionalInfo.tsx">
        Anything else you would like to add?
      </Paragraph>
      <FormInput value={text ?? ""} onChangeText={onChangeText} placeholder="Enter any additional information here" numberOfLines={3} multiline onFocus={onFocus} errorMessage={errorMessage} data-sentry-element="FormInput" data-sentry-source-file="AdditionalInfo.tsx" />
    </YStack>;
}